interface Props {
  minute?: string;
}

export function LiveBadge({ minute }: Props) {
  return (
    <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-live/10 border border-live/20">
      <span className="relative flex w-1.5 h-1.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-live animate-pulse-live" />
      </span>
      <span className="text-[11px] font-mono font-semibold text-live tracking-wide">
        {minute ? minute : "LIVE"}
      </span>
    </div>
  );
}
